import { getUrl } from './base-url';
import { website } from './website';
import type { BreadcrumbList, ImageObject, Thing, WebSite } from 'schema-dts';

export function getSchemaString(graph: Array<Thing | undefined>) {
	return JSON.stringify({
		'@context': 'https://schema.org',
		'@graph': [
			...graph.filter(Boolean),
			website({
				name: 'Golf with Access',
				description:
					'Book tee times, earn points, and unlock exclusive rates at top courses with Access. Play more, save more, and get rewarded for every round.',
				search: '/tee-times?query={search_term_string}',
			}),
		].map((item) => {
			if (!item || typeof item !== 'object') {
				return item;
			}

			if (item['@type'] === 'WebPage') {
				useThing<BreadcrumbList>(graph, 'BreadcrumbList', () => {
					// oxlint-disable-next-line typescript/no-base-to-string
					item.breadcrumb = { '@id': getUrl(`${item.url ?? ''}`, 'breadcrumblist') };
				});
				useThing<WebSite>(graph, 'WebSite', (site) => {
					item.isPartOf = site['@id'] ? { '@id': site['@id'] } : undefined;
				});
				useThing<ImageObject>(graph, 'ImageObject', (image) => {
					item.primaryImageOfPage = image['@id'] ? { '@id': image['@id'] } : undefined;
				});
			}

			return item;
		}),
	});
}

function useThing<T extends Thing>(things: Array<Thing | undefined>, type: string, fn: (thing: T) => void) {
	const thing = things.filter(Boolean).find((thing) => thing && typeof thing === 'object' && thing['@type'] === type);
	if (thing) {
		fn(thing as T);
	}
}
